import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { HeaderModule } from '../../component/common/header/header.module';
import { LabelModule } from '../../component/common/label/label.module';
import { DetailsFaqComponent } from './details-faq.component';
import { IdsModule } from 'src/app/ids.module';
@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    HeaderModule,
    LabelModule,
    IdsModule
  ],
  declarations: [DetailsFaqComponent]
})
export class DetailsFaqModule {}
